import { render } from "./terms_of_use.vue?vue&type=template&id=3d083198"
import script from "./terms_of_use.vue?vue&type=script&lang=js"
export * from "./terms_of_use.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__